import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=64e5f192&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=64e5f192&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5f192",
  null
  
)

export default component.exports